import React from "react";

const Footer = () => {
  return (
    <div class="footer">
      <h5>
        Created with{" "}
        <span role="img" aria-label="heart">
          ❤️
        </span>{" "}
        by{" "}
        <a style={{ color: "white" }} href="https://www.adityavsingh.com/">
          Aditya Vikram Singh
        </a>
        , 2020
      </h5>
    </div>
  );
};

export default Footer;
